export default __webpack_public_path__ + "static/media/img-login-960w.ac40f102.jpg";